import React, { useState, useEffect, useRef } from "react";
import "./style.scss";
import classNames from "classnames";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import ContactSupportSubmitted from "../../sections/contact-support-submitted";
import ContactSupportForm from "../../sections/contact-support-form";
import SuggestedArticles from "../../sections/suggested-articles";
import api from "../../utils/api";
import getArticles from "../../utils/articles";
import { scrollToSmooth } from "../../hooks/scrollToSmooth.js";
import config from "../../temp/config";

const ContactSupport = ({ fields, lang, page }) => {
  let {
    CtaName,
    backgroundColor,
    body,
    captcha,
    colorScheme,
    consent,
    countryRequiredError,
    countryTip,
    defaultError,
    disclaimer,
    emailErrorTipText,
    emailRequiredError,
    emailTipText,
    firstnameLabel,
    firstnameRequired,
    headingBody,
    headingType,
    iconName,
    image,
    lastnameLabel,
    lastnameRequired,
    messageRequiredError,
    messageTipText,
    // nofollowTextlink,
    paddingAboveBottom,
    paddingAboveTop,
    subjectRequiredError,
    subjectTip,
    submittedBody,
    submittedHeadingType,
    submittedheadingBody
  } = fields;

  const currentComponent = useRef();

  const { suggestedArticlesHeadingType, suggestedArticlesHeadingBody, suggestedArticlesIcon, articles } = fields;
  const contactSupportClasses = classNames(`padding-bottom-${paddingAboveBottom?.fields?.phrase?.value}`, `padding-top-${paddingAboveTop?.fields?.phrase?.value}`, "contact-support", "grid"),
    titleClasses = "title";

  let backgroundStyle = backgroundColor
    ? {
        background: backgroundColor.fields.phrase.value
      }
    : {};
  let submitted = {
    submittedheadingBody,
    submittedHeadingType,
    submittedBody,
    image
  };
  let submitting = false;
  let form = {
    firstnameLabel,
    lastnameLabel,
    emailTipText,
    countryTip,
    subjectTip,
    textarea: messageTipText,
    hasCaptcha: captcha?.value,
    captchaSiteKey: config.webSettings.verificationCodeKey,
    hasError: false,
    errorMessage: null,
    countryVisible: lang === "en",
    countryRequiredError,
    subjectRequiredError,
    messageTipText,
    messageRequiredError,
    firstnameRequired,
    lastnameRequired,
    emailRequiredError,
    emailErrorTipText,
    button: {
      colorScheme,
      iconName,
      buttonText: CtaName?.value
    },
    disclaimer: disclaimer
  };
  const [isSubmited, setIsSubmited] = useState(false);
  const [subjects, setSubjects] = useState([]);
  const [countries, setCountries] = useState([]);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [suggestedArticles, setSuggestedArticles] = useState(() => ({
    heading: {
      text: suggestedArticlesHeadingBody,
      type: suggestedArticlesHeadingType
    },
    linkIcon: suggestedArticlesIcon,
    articles: []
  }));

  useEffect(() => {
    if (lang === "en") {
      getCountries();
    }
    getSubjects();
    getSuggestedArticles();
  }, []);
  const getCountries = () => {
    api.country
      .list(null, {
        language: lang
      })
      .then(res => {
        const countries = res.obj.regions.map(e => {
          return {
            id: e.regionId,
            value: e.regionName,
            code: e.regionNo
          };
        });
        setCountries(countries);
      });
  };
  //Get subjects
  const getSubjects = () => {
    api.subjecttype.get({ language: lang }).then(res => {
      setSubjects(
        res?.subjectTypeList.map(item => ({
          value: item.displayName,
          code: item.code
        }))
      );
    });
  };
  const getSuggestedArticles = async () => {
    let articteNumbers = articles?.map(item => item.fields?.articleNumber?.value).join(";");
    getArticles(lang, articteNumbers, articles).then(_articles => {
      setSuggestedArticles({
        heading: {
          text: suggestedArticlesHeadingBody,
          type: suggestedArticlesHeadingType
        },
        linkIcon: suggestedArticlesIcon,
        articles: _articles
      });
    });
  };

  //Bind consent
  const bindConsent = async (email, country, siteRes) => {
    lang = lang.toLowerCase();
    //const siteRes = await api.site.get({ key: lang });
    const countryId = lang === "en" ? (country ? country.id : null) : siteRes.CountryLocal;
    const consentNo = consent ? consent.id : "";
    const body = {
      isSubscriptionFlag: "0",
      receiver: email,
      contentMap: {},
      email: email,
      countryId: countryId,
      consentCode: consentNo
    };
    setHasError(false);
    const bindRes = await api.bind(null, body);
    if (bindRes.code === "CONSENT_EXCEPTION_016") {
      setHasError(true);
      setErrorMessage(emailErrorTipText?.value);
      return bindRes.code;
      // throw new Error(bindRes.msg,bindRes.code);
    } else if (bindRes.code !== "1" && bindRes.code !== "CUSTOMER_SUBSCRIPTION_005") {
      throw new Error(bindRes.msg, bindRes.code);
    }
  };
  //Submit contact
  const onSubmit = async (event, data) => {
    event && event.preventDefault();
    if (!submitting) {
      submitting = true;
      lang = lang.toLowerCase();
      const siteRes = await api.site.get({ key: lang }).catch(() => (submitting = false));
      const bindconsent = await bindConsent(data.email, data.country, siteRes).catch(() => (submitting = false));
      if (bindconsent === "CONSENT_EXCEPTION_016") {
        return false;
      }

      const body = {
        contactInfo: {
          email: data.email,
          firstName: data.firstname,
          lastName: data.lastname,
          country: lang === "en" ? (data.country ? data.country.id : null) : siteRes.CountryLocal,
          preferLanguage: siteRes.CountryleadsLang
        },
        caseInfo: {
          subject: data.subject?.code,
          title: "",
          description: data.message
        },
        clientCode: "0"
      };
      api
        .contact(null, body)
        .then(res => {
          switch (res.status) {
            case 200:
              scrollToSmooth(currentComponent.current);
              setIsSubmited(true);
              window.location.hash = `${page.itemId};submitted`;

              break;
            default:
              setHasError(true);
              setErrorMessage(defaultError?.value || res.msg);
              break;
          }
        })
        .catch(res => {
          setHasError(true);
          setErrorMessage(defaultError?.value || res.Message);
        })
        .finally(() => {
          submitting = false;
        });
    }
  };
  return (
    <div className={contactSupportClasses} style={backgroundStyle} ref={currentComponent}>
      <div className="left">
        {!isSubmited && (
          <React.Fragment>
            {/* header */}
            {headingBody && <Heading html={headingBody} type={headingType} className={titleClasses} typographyClass="type-h1" />}
            <BodyText html={body?.value} />
            <ContactSupportForm
              {...{
                ...form,
                subject: {
                  options: subjects
                },
                countries: {
                  options: countries
                },
                hasError,
                errorMessage,
                onSubmitForm: (event, data) => onSubmit(event, data)
              }}
            />
          </React.Fragment>
        )}

        {isSubmited && <ContactSupportSubmitted {...submitted} />}
      </div>
      {suggestedArticles && <SuggestedArticles {...suggestedArticles} className="right" />}
    </div>
  );
};

export default ContactSupport;
